// import React, { useEffect } from 'react'
import Script from 'next/script'

function Chat({ config }) {

    // useEffect(() => {

    //     if (config.chat_enabled == "true") {

    //         const existing = document.getElementById("chat_widget_script_tag")
    //         if (existing) {
    //             // remove that iframe, and build a new one
    //             existing.remove()
    //         }
    //         var Tawk_API = Tawk_API || {}
    //         var Tawk_LoadStart = new Date();
    //         const script = document.createElement('script');
    //         script.id = "chat_widget_script_tag"
    //         script.async = true;
    //         script.src = 'https://embed.tawk.to/619bc8e76bb0760a4943cbf7/1fl48hiih';
    //         script.charset = 'UTF-8';
    //         script.setAttribute('crossorigin', '*');

    //         // set this before the first script on the page lol
    //         document.body.appendChild(script);

    //     }
    // }, [config]);


    return (
        <>
            {(config.chat_enabled && config.chat_enabled == "true") ? ('') : ('')}
            {/* <Script id="tawkio-chat" src="https://embed.tawk.to/619bc8e76bb0760a4943cbf7/1fl48hiih" strategy="lazyOnload"></Script> */}
        </>
    );
}

export default Chat;